unable to read source [project]/packages/shared/src/studio/slots.ts